import {
  Breadcrumb,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Switch,
} from "antd";
import React, { useMemo, useState } from "react";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import RecentJobsTable from "../Dashboard/RecentJobsTable";
import { IRecipientsListResponse } from "../../../types/api/recipients";
import FilesTable from "./RecipientsTable";
import UploadFoodImage from "../../../lib/UploadFoodImage";
import RecipientsTable from "./RecipientsTable";
import { useLocation, useNavigate } from "react-router-dom";
import RecipientsForm from "./RecipientsForm";
import { useRecipientsDelete, useRecipientsList } from "../../../hooks/api/recipients/hooks";
import { useParams } from "react-router-dom";
import { useMessageApi } from "../../../provider/AntdNotification";

const RecipientsMainComp: React.FC<{ allowURLStateUpdate?: boolean }> = ({
  allowURLStateUpdate = true,
}) => {
  const { id } = useParams<{ id: string }>();

  const message = useMessageApi()

  const navigate = useNavigate();
  const location = useLocation();
  const isCreatePage = location.pathname === "/recipients/create";
  const isEditPage = !!id;

  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useRecipientsList({
    page: 1,
    limit: 20,
    ...DEFAULT_NUQS_CONFIG,
  });

  const recipientsList: IRecipientsListResponse[] = useMemo(
    () => data?.data || [],
    [data]
  );
  const qData = data?.qData ?? { page: 1, limit: 20 }
    const { mutate: deleteJob } = useRecipientsDelete({ qData });
  ;

    const handleDelete = (id: string) => {
    deleteJob(
      { ids: id },
      {
        onSuccess: () => {
          message.success("Recipients deleted successfully");
        },
       onError: (err: any) => {
          const msg =
            err?.response?.data?.message ||
            err?.message ||
            "Failed to delete Recipients";

          message.error(msg);
        },
      }
    );    
  };

  return (
    <div className="mb-6">
      <div className=" flex justify-between items-center">
        <h1 className="text-xl sm:text-3xl  sm:mb-2">
            {isCreatePage
            ? "Add new Recipients"
            : isEditPage
            ? "Edit Recipients"
            : "Recipient Groups"}
        </h1>
        {(!isCreatePage && !isEditPage) && (
          <ButtonWrapper
            className="bg-primary text-white"
            onClick={() => navigate("/recipients/create")}
          >
            Create Group
          </ButtonWrapper>
        )}
      </div>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[
            { title: "Dashboard", href: "/" },
            { title: "Recipient Groups" },
          ]}
        />
      </div>

      <div>
        {isCreatePage || isEditPage ? (
          <RecipientsForm qData={qData} id={id}/>
        ) : (
          <RecipientsTable 
            data={recipientsList} 
            loading={isFetching} 
            qData={qData}
            handleDelete={handleDelete}
            DEFAULT_NUQS_CONFIG={DEFAULT_NUQS_CONFIG}
            refetch={refetch}
          />
        )}
      </div>
    </div>
  );
};

export default RecipientsMainComp;
